'use client';

import { useState } from 'react';

import { ReservationModal } from './reservation-model';
import { RoomCard } from './room-card';

export function ReservablesList({
    reservables,
    customer,
    reservableType,
}: {
    reservables: App.Data.RoomData[] | App.Data.TableData[];
    customer: App.Data.CustomerData | null;
    reservableType: 'room' | 'table';
}) {
    const [selectedRoom, setSelectedRoom] = useState<
        App.Data.RoomData | App.Data.TableData | null
    >(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleReserve = (room: App.Data.RoomData | App.Data.TableData) => {
        setSelectedRoom(room);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedRoom(null);
    };

    return (
        <div className="container">
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
                {reservables.map((room) => (
                    <RoomCard
                        key={room.id}
                        reservable={room}
                        onReserve={() => handleReserve(room)}
                    />
                ))}
            </div>
            {selectedRoom && (
                <ReservationModal
                    customer={customer}
                    room={selectedRoom}
                    reservableType={reservableType}
                    isOpen={isModalOpen}
                    onClose={handleCloseModal}
                />
            )}
        </div>
    );
}
